import { useWindowSize } from "@uidotdev/usehooks";
import { use, useContext, useEffect, useState } from "react";
import StockGraph from "@/components/StocksDetail/StockGraph";
// import StocksHeader from "@/components/StocksDetail/StocksHeader";
import TopBar from "@/components/StocksDetail/TopBar/TopBar";
import ExpertVerdictPhone from "@/components/StocksDetail/Verdict/ExpertVerdictPhone";
import KeyIndicatorCard from "@/components/StocksDetail/KeyIndicatorCard/KeyIndicatorCard";
import CompanyFinancial from "@/components/StocksDetail/CompanyFinancial/CompanyFinancial";
import FinancialIndicator from "@/components/StocksDetail/FinancialIndicator/FinancialIndicator";
import NewsAndEvents from "@/components/StocksDetail/NewsAndEvents/NewsAndEvents";
import PeerComparison from "@/components/StocksDetail/PeerComparison/PeerComparison";
import ShareHolding from "@/components/StocksDetail/ShareHolding/ShareHolding";
import MetaSection from "@/elements/MetaSection/MetaSection";
import { Mixpanel } from "@/elements/Mixpanel";
import PageNotFound from "../404";
import Actions from "@/elements/Actions";
import StockFAQSection from "@/components/Stocks/StockFAQSection";
import { UserDetailProvider } from "@/contexts/UserDetailContext";
import { cn } from "@/lib/utils";
import StockDetailOHLC from "@/components/StocksDetail/StockDetailsOHLC/StockDetailOHLC";
import StockTopDetails from "@/components/StocksDetail/StockTopDetails";
import axios from "axios";
import FNO from "@/components/Markets/Fno/FNO";
import OptionChain from "@/components/StocksDetail/OptionChain";
import { useRouter } from "next/router";
import StockResults from "@/components/StocksDetail/StockResults/StockResults";
import StockDetailsBF from "@/components/StockDetailsBF/StockDetailsBF";
import StocksExtra from "@/components/Stocks/StocksExtra";
import Link from "next/link";
import { AiOutlineRight } from "react-icons/ai";
import Image from "next/image";
import { useSelector } from "react-redux";

export default function StockDetails({
    stockDetails,
    seoData,
    data,
    keyIndicatorCardData,
    isPaidUserPage,
    preActive,
    peerComparison,
    shareHoldingData
}) {
    const [active, setActive] = useState(preActive);
    const router = useRouter();
    const userDetail = useContext(UserDetailProvider);
    const { exchange } = useSelector((state) => state.stocksDetails);
    useEffect(() => {
        setActiveChartType(exchange === "BSE" ? 2 : data?.nseSymbol === null ? 2 : 1);
    }, [exchange]);

    const [activeChartType, setActiveChartType] = useState(1);
    const scriptData = data?.scriptData;

    useEffect(() => {
        const { tab } = router.query;
        if (tab) {
            setActive(tab);
        }
    }, [router.query]);

    useEffect(() => {
        setActive(preActive);
        userDetail.setBtn({
            show: true,
            beforeLogin: "Get started",
            afterLogin: "Download the app now",
            isProPage: true,
            page: "stocks_details"
        });
        // if (stockDetails?.expiryDateWithFinCodeList?.length > 0) {
        //     for (let index = 0; index < stockDetails?.expiryDateWithFinCodeList?.length; index++) {
        //         const element = stockDetails?.expiryDateWithFinCodeList?.[index];
        //         if (element?.expiryDate?.toLowerCase()?.includes(stockDetails?.compName?.split("-")?.[1])) {
        //             setFinCode(element?.finCode);
        //             setActive("fno");
        //             return;
        //         } else {
        //             setFinCode(stockDetails?.finCode);
        //             setActive("overview");
        //         }
        //     }
        // } else {
        //     setFinCode(stockDetails?.finCode);
        //     setActive("overview");
        // }

        // setFinCode(stockDetails?.finCode)
        Mixpanel.pageView({
            page: "stock_details",
            finCode: stockDetails?.finCode,
            symbol: stockDetails?.symbol,
            compName: stockDetails?.compName
        });
    }, [stockDetails?.finCode, preActive]);

    if (stockDetails?.finCode && stockDetails?.finCode !== "") {
        return (
            <div
                className={cn("select-none font-Inter", {
                    "pt-20 md:pt-0 h-full overflow-hidden": isPaidUserPage,
                    "pt-16 lg:pt-24 max-w-screen-xl mx-auto": !isPaidUserPage
                })}
            >
                <StockTopDetails
                    preData={data}
                    finCode={stockDetails?.finCode}
                    activeChartType={activeChartType}
                    setActiveChartType={setActiveChartType}
                    isPaidUserPage={isPaidUserPage}
                />
                <TopBar
                    section={[
                        { id: "overview", text: "Overview" },
                        { id: "fno", text: "F&O" },
                        { id: "charts", text: "Charts" },
                        { id: "option-chain", text: "Option chain" },
                        { id: "results", text: "Results" },
                        { id: "newsAndevents", text: "News & Events" }
                    ]}
                    optionChainAvailable={data?.optionChainAvailable}
                    isPaidUserPage={isPaidUserPage}
                    active={active}
                    setActive={(e) => {
                        setActive(e);
                        Mixpanel.track("tab_clicked", {
                            page: "stock_page",
                            tab: e,
                            symbol: stockDetails?.nseSymbol,
                            fincode: stockId
                        });
                    }}
                    isFNO={stockDetails?.isFNO}
                />
                <div className={cn("w-full mx-4 hidden md:block mt-4", { "md:hidden": isPaidUserPage })}>
                    <ol className="list-reset flex">
                        <li>
                            <Link href="/" className="text-primary text-xs font-medium">
                                Home
                            </Link>
                        </li>
                        <li className=" flex items-end mb-1 px-2">
                            <AiOutlineRight color="#707070" size={14} />
                        </li>
                        <li>
                            <Link href="/stocks" className="text-primary text-xs font-medium">
                                Stocks
                            </Link>
                        </li>
                        <li className=" flex items-end mb-1 px-2">
                            <AiOutlineRight color="#707070" size={14} />
                        </li>
                        <li>
                            <span className="text-primary text-xs font-medium">{`${data?.compName} (${data?.title})`}</span>
                        </li>
                    </ol>
                </div>
                <div
                    className={cn("h-full mb-8 w-full  ", {
                        "overflow-y-auto mb-0 h-[calc(100%-184px)]": isPaidUserPage
                    })}
                >
                    {active === "overview" && (
                        <>
                            {/* <StockTopDetails
                                preData={data}
                                finCode={stockDetails?.finCode}
                                activeChartType={activeChartType}
                                setActiveChartType={setActiveChartType}
                                isPaidUserPage={isPaidUserPage}
                            /> */}
                            {/* stocks */}
                            <ExpertVerdictPhone
                                symbol={`${data?.compName} (${data?.title})`}
                                name={stockDetails?.finCode}
                                activeChartType={activeChartType}
                                isPaidUserPage={isPaidUserPage}
                            />
                            {!isPaidUserPage && (
                                <div className="p-4">
                                    <Image
                                        alt="demo image"
                                        src={
                                            "https://storage.googleapis.com/production-univest/pn_images/1743077058544_trade_carddd.jpeg"
                                        }
                                        width={1200}
                                        height={600}
                                        className="object-contain rounded-lg md:rounded-2xl cursor-pointer"
                                        onClick={() => {
                                            router.push("/user/payment");
                                            Mixpanel.track("banner_clicked", {
                                                page: "stock_page",
                                                widget: "free_trades",
                                                cta_text: "free_trades"
                                            });
                                        }}
                                    />
                                </div>
                            )}
                            <StockGraph
                                preData={data}
                                activeChartType={activeChartType}
                                name={stockDetails?.finCode}
                                isFNO={stockDetails?.isFNO && stockDetails?.finCode > 10000000}
                                setActive={setActive}
                            />
                            <StockDetailOHLC preData={data} scriptData={scriptData} activeChartType={activeChartType} />
                            <KeyIndicatorCard
                                data={keyIndicatorCardData}
                                symbol={`${data?.compName} (${data?.title})`}
                                isPaidUserPage={isPaidUserPage}
                            />
                            {!isPaidUserPage && (
                                <div className="p-4 pt-0">
                                    <Image
                                        alt="demo image"
                                        src={
                                            "https://storage.googleapis.com/production-univest/pn_images/1743077058844_broker_kyc.jpeg"
                                        }
                                        width={1200}
                                        height={600}
                                        className="object-contain rounded-lg md:rounded-2xl cursor-pointer"
                                        onClick={() => {
                                            router.push("/user/broker-kyc");
                                            Mixpanel.track("banner_clicked", {
                                                page: "stock_page",
                                                widget: "free_trades",
                                                cta_text: "free_trades"
                                            });
                                        }}
                                    />
                                </div>
                            )}
                            <div className="flex flex-col lg:flex-row justify-between w-full gap-4 lg:px-4">
                                <CompanyFinancial
                                    name={stockDetails?.finCode}
                                    symbol={`${data?.compName} (${data?.title})`}
                                    isPaidUserPage={isPaidUserPage}
                                />
                                <FinancialIndicator
                                    name={stockDetails?.finCode}
                                    symbol={`${data?.compName} (${data?.title})`}
                                    isPaidUserPage={isPaidUserPage}
                                />
                            </div>
                            <PeerComparison
                                name={stockDetails?.finCode}
                                symbol={`${data?.compName} (${data?.title})`}
                                isPaidUserPage={isPaidUserPage}
                                peerComparison={peerComparison}
                            />
                            {!isPaidUserPage && (
                                <div className="px-4">
                                    <Image
                                        alt="demo image"
                                        src={
                                            "https://storage.googleapis.com/production-univest/pn_images/1743077058544_trade_carddd.jpeg"
                                        }
                                        width={1200}
                                        height={600}
                                        className="object-contain rounded-lg md:rounded-2xl cursor-pointer"
                                        onClick={() => {
                                            router.push("/user/payment");
                                            Mixpanel.track("banner_clicked", {
                                                page: "stock_page",
                                                widget: "free_trades",
                                                cta_text: "free_trades"
                                            });
                                        }}
                                    />
                                </div>
                            )}
                            <ShareHolding
                                name={stockDetails?.finCode}
                                symbol={`${data?.compName} (${data?.title})`}
                                shareHoldingData={shareHoldingData}
                                isPaidUserPage={isPaidUserPage}
                            />
                            <StocksExtra
                                isPaidUserPage={isPaidUserPage}
                                data={data}
                                seoData={seoData}
                                shareHoldingData={shareHoldingData}
                                peerComparison={peerComparison}
                            />
                        </>
                    )}
                    {active === "fno" && (
                        <FNO
                            isPaidUserPage={isPaidUserPage}
                            data={data}
                            activeChartType={activeChartType}
                            setActiveChartType={setActiveChartType}
                            stocksDetail={stockDetails}
                            scriptData={scriptData}
                        />
                    )}
                    {active === "charts" && (
                        <iframe
                            className="w-full h-full overflow-hidden min-h-[400px]"
                            src={Actions.toChartUrl(
                                scriptData?.[activeChartType === 1 ? "NSE" : "BSE"],
                                activeChartType === 1 ? "NSE" : "BSE",
                                data?.instrumentName,
                                data?.nseSymbol ?? data?.bseSymbol
                            )}
                        />
                    )}
                    {active === "option-chain" && (
                        <OptionChain
                            name={stockDetails?.finCode}
                            scriptData={scriptData?.[activeChartType === 1 ? "NSE" : "BSE"]}
                            source={"stock_details"}
                        />
                    )}
                    {active === "results" && (
                        <>
                            {/* <StockTopDetails
                                preData={data}
                                finCode={stockDetails?.finCode}
                                activeChartType={activeChartType}
                                setActiveChartType={setActiveChartType}
                                isPaidUserPage={isPaidUserPage}
                            /> */}
                            <StockResults name={stockDetails?.finCode} />
                        </>
                    )}
                    {active === "newsAndevents" && (
                        <>
                            {/* <StockTopDetails
                                preData={data}
                                finCode={stockDetails?.finCode}
                                activeChartType={activeChartType}
                                setActiveChartType={setActiveChartType}
                                isPaidUserPage={isPaidUserPage}
                            /> */}
                            <NewsAndEvents name={stockDetails?.finCode} symbol={data?.nseSymbol ?? data?.bseSymbol} />
                        </>
                    )}
                    <StockFAQSection
                        keyIndicatorCardData={keyIndicatorCardData}
                        data={data}
                        stockDetails={stockDetails}
                        isPaidUserPage={isPaidUserPage}
                    />
                </div>
            </div>
        );
    } else {
        return <PageNotFound />;
    }
}

export async function getServerSideProps({ query, res, req, resolvedUrl }) {
    const { params } = query;
    // console.log(query);
    const paramsOld = params?.[0].split("~");
    const symbol = params?.[0]?.replaceAll("-and-", "&");
    if (
        Actions.toStockDetailOld(paramsOld[0], paramsOld[1]) ===
        `/stocks/${encodeURIComponent(params?.[0]?.replaceAll(" ", "-"))}`
    ) {
        res.writeHead(301, {
            location: Actions.toStockDetail(paramsOld[0], paramsOld[1])
        });
        res.end();
        return {
            props: {}
        };
    }
    let [resp, res3] = await Promise.all([
        axios
            .get(
                `${process.env.apiBaseURL}/resources/stock-details/symbol-fincode-exchange?symbol=${encodeURIComponent(
                    symbol?.toUpperCase()
                )}&is-index=false`
            )
            .catch((e) => ({})),
        axios
            .get(
                `${
                    process.env.apiBaseURL
                }/resources/stock-details/stock-additional-details?symbol=${symbol?.toUpperCase()}`
            )
            .catch((e) => ({}))
    ]);

    // for wrongh url
    const location = Actions.toStockDetail(
        resp.data?.pricesData?.nseSymbol ?? resp.data?.pricesData?.bseSymbol,
        resp.data?.pricesData?.compName,
        params?.[2] ? `/${params?.[2]}` : ""
    );
    if (!resolvedUrl?.includes(location)) {
        res.writeHead(301, {
            location
        });
        res.end();
        return {
            props: {}
        };
    }
    //for nfo
    if (resp.data?.pricesData?.isNfo) {
        res.writeHead(301, {
            location: Actions.toStockDetail(
                resp.data?.pricesData?.compName,
                resp.data?.pricesData?.compName,
                params?.[2] ? `/${params?.[2]}` : ""
            )
        });
        res.end();
        return {
            props: {}
        };
    }

    let finCode = resp.data?.finCode ?? 0;

    let [res4, res5, footerContentRes] = await Promise.all([
        axios.get(`${process.env.apiBaseURL}/resources/stock-details/${finCode}/peer-comparison`).catch((e) => ({})),
        axios.get(`${process.env.apiBaseURL}/resources/stock-details/${finCode}/holdings/all`).catch((e) => ({})),
        axios.get(`${process.env.apiBaseURL}/resources/web/footer-sections`).catch(() => ({ data: null }))
    ]);

    let data = resp?.data?.pricesData ?? {};
    let keyIndicatorCardData = res3?.data?.keyIndicators ?? {};
    let seoData = res3?.data ?? {};
    const peerComparison = res4?.data ?? [];
    const shareHoldingData = res5?.data ?? [];

    return {
        props: {
            stockDetails: {
                finCode,
                isFNO: data?.expiryDateWithFinCodeList?.length > 0,
                expiryDateWithFinCodeList: data?.expiryDateWithFinCodeList ?? [],
                symbol: (params?.[0] ?? "")?.toUpperCase(),
                compName: params?.[1] ?? params?.[0] ?? ""
            },
            seoData,
            params: params?.[0],
            pageName: "stock-details",
            isPaidUserPage: !!req.cookies["auth_token"],
            data,
            keyIndicatorCardData,
            preActive: params?.[2] ?? "overview",
            peerComparison,
            shareHoldingData,
            footerContentData: footerContentRes?.data ?? null
        }
        // revalidate: 59
    };
}

// export async function getStaticPaths() {
//     return {
//         paths: ["/hdfcbank/hdfc-bank-ltd-share-price-today"].map((params) => ({
//             params:{

//             }
//         })),
//         fallback: true
//     };
// }
